import StarSeekerIcon from '../../assets/svg/star-seeker.svg?react';
import { cn } from '../../lib/utils';

interface StarRatingProps {
  /** 0–5, fractional values render a partially filled star. */
  rating: number;
  /** Star size in px (Figma: 10 in distributions, 14 in lists, 36 in heroes). */
  size?: number;
  className?: string;
  label?: string;
}

/** Five "star-seeker" glyphs; filled stars are white, empty ones muted. */
export function StarRating({
  rating,
  size = 14,
  className,
  label,
}: StarRatingProps) {
  const clamped = Math.max(0, Math.min(5, rating));

  return (
    <span
      role="img"
      aria-label={label ?? `${clamped.toFixed(1)} out of 5 stars`}
      className={cn('inline-flex items-center gap-px', className)}
    >
      {[0, 1, 2, 3, 4].map((index) => {
        const fill = Math.max(0, Math.min(1, clamped - index));
        return (
          <span
            key={index}
            className="relative inline-block shrink-0 text-seeker-700"
            style={{ width: size, height: size }}
          >
            <StarSeekerIcon className="absolute inset-0 size-full fill-current" />
            {fill > 0 ? (
              <span
                className="absolute inset-y-0 left-0 overflow-hidden text-white"
                style={{ width: `${fill * 100}%` }}
              >
                <StarSeekerIcon
                  className="absolute inset-y-0 left-0 fill-current"
                  style={{ width: size, height: size }}
                />
              </span>
            ) : null}
          </span>
        );
      })}
    </span>
  );
}
